module.exports = __webpack_public_path__ + "img/tasty-hemp-oil-drops.f982b868.jpg";